import theme from '@/style';
import {ImageBackground, ImageSourcePropType, View} from 'react-native';
import Text from '@/components/basic/text';
import React from 'react';
import {BasicObject} from '@/types';

export interface DigitBallProps {
  ballSize?: number;
  digit: string;
  color: string;
  fontSize?: number;
  emptyType?: string;
  backgroundImage?: ImageSourcePropType;
}

const COLOR_MAP = {
  A: '#DE3C3F',
  B: '#EC8305',
  C: '#046FEA',
} as BasicObject;

const DigitBall = ({
  ballSize = 32,
  digit,
  color = 'A',
  fontSize = 12,
  emptyType = '*',
  backgroundImage,
}: DigitBallProps) => {
  const backgroundColor =
    digit === '-' && emptyType === '*'
      ? '#C6C6C6'
      : COLOR_MAP[color] || COLOR_MAP.A;

  const ballStyle = {
    width: ballSize,
    height: ballSize,
    borderRadius: ballSize / 2,
    overflow: 'hidden' as const,
  };

  const content = (
    <View
      style={[
        theme.flex.center,
        {
          width: ballSize,
          height: ballSize,
          borderRadius: ballSize / 2,
          backgroundColor: backgroundImage ? undefined : backgroundColor,
        },
      ]}>
      <Text
        fontSize={fontSize}
        fontFamily="fontInterBold"
        color={theme.basicColor.white}>
        {digit}
      </Text>
    </View>
  );

  if (backgroundImage) {
    return (
      <ImageBackground
        source={backgroundImage}
        resizeMode="cover"
        style={[theme.flex.center, ballStyle]}>
        <Text
          fontSize={fontSize}
          fontFamily="fontInterBold"
          color={theme.basicColor.white}>
          {digit}
        </Text>
      </ImageBackground>
    );
  }

  return content;
};

export default DigitBall;
